<!--  -->
<template>
  <div class="result">
    <el-dialog
      title="自主上传其他成果（2009年以来完成）"
      align="center"
      @close="handleClose"
      :visible.sync="dialogVisible"
      width="720px"
    >
      <div class="paper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="类型：" prop="resource">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio label="[J] 期刊论文"></el-radio>
              <el-radio label="[J] 期刊论文"></el-radio>
              <el-radio label="[J] 期刊论文"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="标题：" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="其他作者：" prop="otherscholar">
            <el-input v-model="ruleForm.otherscholar"></el-input>
          </el-form-item>
          <el-form-item label="关键词：" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="摘要/简介：" prop="desc">
            <el-input type="textarea" v-model="ruleForm.desc"></el-input>
          </el-form-item>
          <el-form-item label="发表出处：" prop="source">
            <el-input v-model="ruleForm.source"></el-input>
            <el-checkbox label="未发表（首发）" name="type"></el-checkbox>
          </el-form-item>
          <el-form-item label="发表/完成年份：" prop="date1" required>
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.date1"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="作者自评：" prop="writer">
            <el-input type="textarea" v-model="ruleForm.writer"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      data: {},
      ruleForm: {
        name: "",
        date1: "",
        resource: "",
        desc: "",
        title: "",
        otherscholar: "",
        source: "",
        writer:""
      },
      rules: {
        name: [
          { required: true, message: "请输入关键词", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        resource: [
          { required: true, message: "请选择类型", trigger: "change" }
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
        writer: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        source: [{ required: true, message: "请输入发表出处", trigger: "blur" }]
      }
    };
  },
  props: {
    detailValue: String
    // props: ['post'],
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.dialogVisible = true;
    },
    handleClose() {
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.result input{
  width: 350px;
}
.result label{
  width: 130px !important;
}
.result .el-form-item__content{
  margin-left: 130px !important;
}
.mb20 {
  margin-bottom: 20px;
}
.mt20 {
  margin-top: 20px;
}
.result .paper {
  text-align: left;
  padding: 0 20px 0 0;
}
.paper h5 {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.paper .rdfyk {
  color: #4267b2;
}
.paper .rdfyk::before {
  content: " ";
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 2px;
  display: inline-block;
  height: 14px;
  width: 16px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/paperotherresult.vue